export const GET_SPECIALISTS_FOR_DEPARTMENT = 'specialist_vertical/GET_SPECIALISTS_FOR_DEPARTMENT'
export const ASSIGN_SPECIALTY = 'specialist_vertical/ASSIGN_SPECIALTY'
